import React from "react";
import Label from "../Label/Label";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import c from "lib/style/colorVar.scss";
import TextMAS from "components/TextMAS/TextMAS";
import HelperMessage from "components/Input/HelperMessage/HelperMessage";

/**
 * Radio buttons input component
 *
 * @param {Object} props
 * @param {[{
 *      label: string;
 *      value: any;
 *    }]} props.options - array of configs for radio buttons
 * @returns
 */

const RadioInput = ({
  id,
  label,
  mandatory,
  value,
  onChange,
  options,
  errorMessage,
  noErrorMessage,
  sxParams = {},
  fontWeight,
}) => {
  const { radioInputError } = sxParams;
  return (
    <div>
      <Label label={label} mandatory={mandatory} />
      <FormControl>
        <RadioGroup row name={id} value={value} onChange={onChange}>
          {options.map((option) => {
            return (
              <FormControlLabel
                key={option.label}
                control={
                  <Radio
                    disableRipple
                    sx={{
                      "&.Mui-checked": {
                        color: c.brand1,
                      },
                      padding: "4px",
                    }}
                  />
                }
                sx={{
                  "&.MuiFormControlLabel-root": {
                    margin: "0px 6px 0px -4px",
                  },
                }}
                value={option.value}
                label={
                  <TextMAS fontWeight={fontWeight ?? "semibold"}>
                    {option.label}
                  </TextMAS>
                }
              />
            );
          })}
        </RadioGroup>
      </FormControl>
      {!noErrorMessage && (
        <HelperMessage message={radioInputError && errorMessage} />
      )}
    </div>
  );
};

export default RadioInput;
